import { T, THtml } from "@/components/editable/T";

const PAGE = "privacy";

const PrivacyStatement = () => {
  return (
    <section className="pt-[120px] pb-20">
      <div className="px-[10%]"><div className="mx-auto max-w-7xl">
        <h1 className="text-foreground mb-10 text-xl md:text-2xl">
          <T page={PAGE} k="title" d="Privacy Statement" />
        </h1>

        <div className="prose max-w-none text-foreground/80 prose-headings:text-base prose-headings:font-bold [&_h3]:text-foreground [&_h3]:mt-10 [&_h3]:mb-4 [&_p]:mb-4 [&_p]:leading-relaxed [&_p]:text-base [&_ul]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul>li]:mb-2 [&_table]:block [&_table]:overflow-x-auto [&_table]:w-full [&_table]:mb-6 [&_table]:border-collapse [&_table]:rounded-lg [&_th]:text-left [&_th]:p-3 [&_th]:border [&_th]:border-border [&_th]:bg-muted [&_th]:font-semibold [&_th]:text-foreground [&_th]:whitespace-nowrap [&_td]:p-3 [&_td]:border [&_td]:border-border [&_td]:min-w-[140px] [&_a]:text-primary [&_a]:underline">
          <THtml page={PAGE} k="content" as="div" />
        </div>
      </div></div>
    </section>
  );
};

export default PrivacyStatement;
